import { render, staticRenderFns } from "./Levels.vue?vue&type=template&id=cdcf7a62&scoped=true&"
import script from "@/views/Users/Student/Levels.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Levels.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/levels.scss?vue&type=style&index=0&id=cdcf7a62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcf7a62",
  null
  
)

export default component.exports